export default "__VITE_ASSET__BXjFAnIr__"